import { LOCALE, TZ } from '@/utils/intl.js';
import store from '@/utils/local-storage.js';

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

function getBrowserIdentity() {
  const identity = [
    $event.browserId || null,
    $event.instanceId || null,
    LOCALE || null,
    Intl.DateTimeFormat().resolvedOptions().locale || null,
    TZ || null
  ];
  return CHARS[ _.random(0, CHARS.length - 1) ] + btoa(JSON.stringify(identity)).replace(/=+$/, '');
}

export default getBrowserIdentity;
